import { ref } from '@vue/composition-api';

import { getRecommendationsSave } from '@/utils/recommendationProductsUser';

import useAuthorizations from '@/compositions/user/useAuthorizations';

const useCashbackBlock = () => {
  const { isAuthorized } = useAuthorizations();

  const plBonusesForOrder = ref(0);

  const recommendationProduct = ref([]);

  const getRecommendationProducts = (productIdList = []) => {
    if (isAuthorized.value && Array.isArray(productIdList) && !!productIdList.length) {
      const savedRecoList = getRecommendationsSave();
      const recoProductsInCart = productIdList.filter(item => savedRecoList.includes(String(item)));

      if (recoProductsInCart.length) {
        recommendationProduct.value = recoProductsInCart;
      }
    }
  };

  return {
    plBonusesForOrder,
    recommendationProduct,
    getRecommendationProducts,
  };
};

export default useCashbackBlock;
